import React from 'react';
import { Linkedin, Github, Mail, Heart, Phone } from 'lucide-react';
import { useTheme } from '../context/ThemeContext';

const Footer = () => {
  const { isDarkMode } = useTheme();
  
  return (
    <footer className={`${
      isDarkMode ? 'bg-primary text-white' : 'bg-gray-200 text-gray-800'
    } py-6 transition-colors duration-300`}>
      <div className="container mx-auto px-4">
        <div className="flex flex-col md:flex-row justify-between items-center">
          {/* Left side - Social links */}
          <div className="flex space-x-4 mb-4 md:mb-0">
            <SocialLinks isDarkMode={isDarkMode} />
          </div>
          
          {/* Right side - Copyright and contact info */}
          <div className="text-center md:text-right">
            <div className="flex items-center justify-center md:justify-end mb-2">
              <span>Made with Love</span>
              <Heart className="w-5 h-5 mx-1 text-red-500 fill-current" />
              <span>| © Jessile Joyce Bonzo 2026</span>
            </div>
            <div className="flex flex-col md:items-end text-sm">
              <a
                href="https://mail.google.com/mail/?view=cm&fs=1&to=jessilebonzo.dev@gmail.com"
                target="_blank"
                rel="noopener noreferrer"
                aria-label="Email"
                className={`${
                  isDarkMode
                    ? "text-gray-400 hover:text-white"
                    : "text-gray-600 hover:text-gray-900"
                } transition-colors`}
              >
                jessilebonzo.dev@gmail.com
              </a>
              <div className="flex items-center justify-center md:justify-end mt-1">
                <Phone className="w-4 h-4 mr-1" />
                <span className={isDarkMode ? 'text-gray-400' : 'text-gray-600'}>
                  +63 994 641 6623
                </span>
              </div>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
};

const SocialLinks = ({ isDarkMode }) => (
  <>
    {[
      {
        icon: Linkedin,
        url: "https://www.linkedin.com/in/jessile-joyce-bonzo/",
        label: "LinkedIn",
      },
      {
        icon: Github,
        url: "https://github.com/jessilebonzo",
        label: "GitHub",
      },
      {
        icon: Mail,
        url: "https://mail.google.com/mail/?view=cm&fs=1&to=jessilebonzo.dev@gmail.com",
        label: "Email",
      },
    ].map(({ icon: Icon, url, label }, index) => (
      <a
        key={index}
        href={url}
        {...(!url.startsWith("mailto:") && {
          target: "_blank",
          rel: "noopener noreferrer",
        })}
        aria-label={label}
      >
        <Icon
          className={`w-8 h-8 ${
            isDarkMode
              ? "text-secondary hover:text-secondary/80"
              : "text-purple-700 hover:text-purple-900"
          } transition-colors`}
        />
      </a>
    ))}
  </>
);

export default Footer;